export default [
	{
		path: '/categories',
		name: 'categories',
		component: () => import('@/views/Category/Categories.vue'),
		meta: { requiresAuth: true, permission: 'view_categories' }
	},
	{
		path: '/categories/create',
		name: 'categories.create',
		component: () => import('@/views/Category/CreateCategory.vue'),
		meta: { requiresAuth: true, permission: 'create_category' }
	}
]
